import React, { Fragment } from "react";
import Loading from "../loading/LoadingWord";
import "./TabbedSectionComponent.css";

export default class TabbedSectionComponent extends React.Component {
  constructor(props) {
    super(props);

    let generateTabNameFn = this.generateTabName;
    if (props.generateTabNameFn) {
      generateTabNameFn = props.generateTabNameFn;
    }

    this.state = {
      tabContents: this.props.tabContents,
      generateTabNameFn
    };

    this.setActiveComponent = this.setActiveComponent.bind(this);
  }

  setActiveComponent(tabName, component) {
    this.setState({
      activeComponent: component,
      activeTabName: tabName
    });
  }

  hasActiveTab() {
    return this.state.activeTabName;
  }

  setActiveTab(tabContents) {
    if (this.hasActiveTab()) {
      return;
    }

    if (!tabContents) {
      tabContents = [];
    }

    if (tabContents.length > 0) {
      let activeTab = tabContents[0];
      if (this.props.activetab) {
        activeTab = tabContents[this.props.activetab];
      }
      const tabName = activeTab.name;
      const { component } = activeTab;

      this.setActiveComponent(tabName, component);
    }
  }

  componentDidMount() {
    const { tabContents } = this.state;

    this.setActiveTab(tabContents);
  }

  componentWillReceiveProps(props) {
    const { tabContents } = props;
    this.setState({ tabContents });
    this.setActiveTab(tabContents);
  }

  componentWillUpdate(props) {
    if (this.props !== props) {
      const { tabContents = [] } = props;
      const activeContent = tabContents.find((each) => {
        return each.name === this.state.activeTabName;
      });
      const activeComponent = activeContent
        ? activeContent.component
        : tabContents.length
        ? tabContents[0].component
        : null;
      this.setState({ tabContents, activeComponent });
    }
  }

  generateTabName(tabContent, className, setActiveComponentFn) {
    const tabName = tabContent.name;
    const { component } = tabContent;
    return (
      <div
        key={tabName}
        className={className}
        onClick={() => {
          return setActiveComponentFn(tabName, component);
        }}
      >
        {tabName}
      </div>
    );
  }

  renderMainContent() {
    // THIS IS A TEMPORARY WORKAROUND, IDEALLY THIS WHOLE THING SHOULD BE REDONE IN HOOKS
    const { activeTabName, tabContents = [] } = this.state;
    const tab = tabContents.find((element) => {
      return element.name === activeTabName;
    });
    let CurrentComponent;
    if (tab) {
      const { component, rule, onLoad, result } = tab;
      if (component && rule) {
        const {
          locationCategory,
          shipmentsTrackingLocationCategory,
          locationDataList,
          trackingSessionList,
          itemTypeData,
          locationTreeMap
        } = result;
        CurrentComponent = component(
          rule.ruleId,
          rule.ruleConditions,
          locationDataList,
          itemTypeData || [],
          onLoad,
          rule.ruleConfig,
          rule.subscriptions,
          locationCategory,
          shipmentsTrackingLocationCategory,
          trackingSessionList,
          locationTreeMap
        );
      } else {
        CurrentComponent = component;
      }
    }
    return CurrentComponent ? <CurrentComponent /> : undefined;
  }

  render() {
    const activeTab = this.state.activeTabName;

    let rootClassName = "tabbedSectionComponent-container";
    if (this.props.className) {
      rootClassName += ` ${this.props.className}`;
    }

    return (
      <div className={rootClassName}>
        {!this.state.tabContents ? (
          <Loading />
        ) : (
          <>
            <div className="tabbedSectionComponent-tabs">
              {this.state.tabContents.map((tabContent) => {
                const tabName = tabContent.name;

                let className = "tab";
                if (activeTab === tabName) {
                  className = `${className} active`;
                } else {
                  className = `${className} clickable`;
                }

                const tabTag = this.state.generateTabNameFn(tabContent, className, this.setActiveComponent);
                return tabTag;
              })}
            </div>
            <div className="tabbedSectionComponent-content">{this.renderMainContent()}</div>
          </>
        )}
      </div>
    );
  }
}
